import { Text } from '@chakra-ui/react'

import Image from '@/features/Services/components/atoms/Images/Cookies'

import { TITLE_H1_STYLE, TITLE_H3_STYLE, PARAGRAPH_STYLE } from './style'

import { Policy } from '@/features/Services/types'

const HREF = 'serviceCookie'

const TITLE = 'Cookie Policy'
const SUBTITLE = 'นโยบายเกี่ยวกับคุกกี้'

const PRIMARY_COLOR = '#EA834F'
const SECONDARY_COLOR = '#FDF3ED'
const LINK_IMAGE = '/images/services/cookie/4.png'
const GRADIENT = `linear-gradient(0deg, rgba(234, 131, 79, 0.5) 0%, ${PRIMARY_COLOR} 100%)`

const POLICY: Policy[] = [
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        Cookie Policy
        <br />
        นโยบายเกี่ยวกับคุกกี้
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        สำหรับเว็บไซต์ที่ใช้คุกกี้เก็บข้อมูลส่วนบุคคลของผู้ใช้ งาน
        เพื่อเก็บข้อมูลที่ระบุตัวตนได้ของผู้ใช้งานเช่น IP Address,
        ข้อมูลการล็อกอินรวมถึงคุกกี้สำหรับ การวัดผลต่างๆ เช่น Google Analytics
        หรือ Facebook Pixel
      </Text>
    ),
    image: '/images/services/cookie/cookie-header.svg',
    imageAspectRatio: 645 / 652,
    button: {
      label: 'สร้าง Policy ตอนนี้!',
      href: '/create/policy?template=cookie',
      logEvent: {
        ga: { category: TITLE, action: 'Click create policy' },
      },
    },
  },
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        Cookie Policy
        <br />
        จำเป็นอย่างไร ?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        คุกกี้ (Cookies) เป็น ชุดข้อมูลที่สามารถใช้ระบุตัวตน
        ของผู้เข้าชมเว็บไซต์ได้จัดเป็นข้อมูลส่วนบุคคล
        ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล เนื่องจาก เป็นชุดข้อมูลที่สามารถ
        ใช้ระบุตัวตนของผู้เข้าชม เว็บไซต์ได้ จากการนำไปประกอบกับข้อมูลอื่น ๆ
        ดังนั้น สำหรับธุรกิจที่มีการใช้คุกกี้ในหน้าเว็บไซต์จึงมีความจำ
        เป็นที่จะต้องจัดทำ นโยบายการใช้คุกกี้ (Cookie Policy)
        เพื่อแจ้งจุดประสงค์ของการจัดเก็บ และ ประมวลผลข้อมูล
        ส่วนบุคคลที่ได้จากการใช้คุกกี้ ตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ.
        2562
      </Text>
    ),
    image: '/images/services/cookie/2.png',
    imageAspectRatio: 770 / 561,
  },
  {
    title: (
      <Text as="h2" sx={TITLE_H3_STYLE}>
        Cookie Policy
        <br />
        ครอบคลุมเรื่องอะไรบ้าง?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        นโยบายการใช้คุกกี้ (Cookie Policy) ครอบคลุมไปถึง ความหมาย วิธีการใช้
        ประเภทของคุกกี้ที่ใช้ และวัตถุประสงค์ในการใช้คุกกี้ ในการเก็บรวบรวม ใช้
        หรือเปิดเผยคุกกี้ ภายใต้ฐานในการประมวลผลข้อมูลและ
        สิทธิเกี่ยวกับข้อมูลส่วนบุคคล
      </Text>
    ),
    checkList: [
      'ปรับใช้ได้กับทุกเว็บไซต์',
      'ครอบคลุมทั้ง GDPR และ PDPA',
      '1 ฉบับได้รับทั้ง ภาษาไทย และภาษาอังกฤษ',
    ],
    image: <Image />,
  },
]

export default {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  POLICY,
  HREF,
  LINK_IMAGE,
  GRADIENT,
  TITLE,
  SUBTITLE,
}
